import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'



import {
    isPrimitive,
    cotizacion,
    pasajero,
    trayecto,
    asistencia,
    solicitudcenco,
    guid
} from '../utils/helpers'


const INITIAL_STATE = Immutable.fromJS({
    id: null,
    estado: 0,
    solicitud: {},
    aprobadores: {},
    unchaged: {},
    btnSaveDisabled: true,
    btnRComprasDisabled: true,
    modified: [],
	modalAddCotizacion: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false
    },
	modalAddTiquete: {
		title: '',
        show: false,
        index: null,
		data: null,
		btnDisabled: false
    },
	modalSelectVersion: {
		title: '',
        show: false,
        index: null,
		data: null,
		btnDisabled: false
    },

	modalAddAsistencia: {
		title: '',
        show: false,
        index: null,
		data: null,
		btnDisabled: false
    },

    addModificacion: false,

    comentario: {
        id: null,
        texto: null,
        btnSendDisabled: false
    },
    flagAdjunto: false,
    adjuntos: []
})

export default function (state = INITIAL_STATE, action) {

    let index , adjuntos

	switch (action.type) {

        case types.ADICIONAR_MODIFICACION_SOLICITUD_TIQUETESAEREO:
            state = state.set('modified', state.get('modified').filter(x => x.get('entity') + x.get('attribute') + x.get('id') !== action.payload.entity + action.payload.attribute + action.payload.id))
            state = state.update('modified', list => list.push(Immutable.fromJS(action.payload)))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
            return state


        case types.OBTENER_SOLICITUD_TIQUETESAEREO:
            action.payload.solicitud.cotizaciones = action.payload.solicitud.cotizaciones.filter(cot =>
                cot.viaje.filter(v => v.activo).length > 0
            )
            action.payload.aprobadores = action.payload.aprobadores.filter(a1 => {
                a1.aprobaciones = a1.aprobaciones.filter(a2 => {
                    return action.payload.solicitud.cotizaciones.findIndex(cot => a2.cotizacione.id == cot.id) >= 0
                })
                return a1.aprobaciones.length > 0;
            })
			state = state.set('id', action.payload.solicitud.id)
			state = state.set('estado', action.payload.solicitud.estado)
            state = state.set('solicitud', Immutable.fromJS(action.payload.solicitud))
            state = state.set('unchaged', Immutable.fromJS(action.payload.solicitud))
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            if (action.payload.reset !== false) {
                state = state.set('modified', INITIAL_STATE.get('modified'))
            }
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)


            state.getIn(['solicitud', 'cotizaciones']).map((c,i) => {
                c.get('aprobaciones').map((a,j) => {
                    state = state.setIn(['solicitud', 'cotizaciones', i, 'aprobaciones', j, 'selected'], false)
                })
            })

            return state


		case types.MOSTRAR_MODAL_ADICIONAR_COTIZACION_TIQUETESAEREO:
			state = state.setIn(['modalAddCotizacion', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalAddCotizacion', 'title'], action.payload.title)
                state = state.setIn(['modalAddCotizacion', 'mode'], action.payload.mode)
                if (action.payload.mode === 'create') {
                    state = state.setIn(['modalAddCotizacion', 'data'], Immutable.fromJS(cotizacion()))
                } else if (action.payload.mode === 'edit') {
                    state = state.setIn(['modalAddCotizacion', 'data'], state.getIn(['solicitud', 'cotizaciones', action.payload.index]))
                }
            } else {
                state = state.set('modalAddCotizacion', INITIAL_STATE.get('modalAddCotizacion'))
            }


            return state

        case types.MOSTRAR_MODAL_ADICIONAR_TIQUETE:
            state = state.setIn(['modalAddTiquete', 'show'], action.payload.show)

            if (action.payload.show) {
                state = state.setIn(['modalAddTiquete', 'title'], action.payload.title)
                state = state.setIn(['modalAddTiquete', 'index'], action.payload.index)
                state = state.setIn(['modalAddTiquete', 'data'], state.getIn(['solicitud', 'viaje', 'pasajeros', action.payload.index]))

            } else {
                state = state.set('modalAddTiquete', INITIAL_STATE.get('modalAddTiquete'))
            }
            return state

        case types.MOSTRAR_MODAL_SELECCIONAR_VERSION_TIQUETESAEREO:
            state = state.setIn(['modalSelectVersion', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalSelectVersion', 'title'], action.payload.title)
                state = state.setIn(['modalSelectVersion', 'index'], action.payload.index)
                state = state.setIn(['modalSelectVersion', 'data'], Immutable.fromJS(action.payload.data))

            } else {
                state = state.set('modalSelectVersion', INITIAL_STATE.get('modalSelectVersion'))
            }
            return state

        case types.MOSTRAR_MODAL_ADICIONAR_ASISTENCIA:
            state = state.setIn(['modalAddAsistencia', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalAddAsistencia', 'title'], action.payload.title)
                state = state.setIn(['modalAddAsistencia', 'index'], action.payload.index)
                state = state.setIn(['modalAddAsistencia', 'data'], state.getIn(['solicitud', 'viaje', 'pasajeros', action.payload.index]))

            } else {
                state = state.set('modalAddAsistencia', INITIAL_STATE.get('modalAddAsistencia'))
            }
            return state


        case types.MODIFICAR_INPUTS_SOLICITUD_TIQUETESAEREO1:
            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'responsable_compras' || action.payload.path.split('.').slice(-1)[0] == 'solicitante') {
                state = state.set('btnRComprasDisabled', false)
            }

            if (state.getIn(['solicitud', 'viaje', 'cant_pasajeros']) > state.getIn(['solicitud', 'viaje', 'pasajeros']).count()) {
                for(let i=state.getIn(['solicitud', 'viaje', 'pasajeros']).count(); i < state.getIn(['solicitud', 'viaje', 'cant_pasajeros']); i++) {
                    const p = pasajero();
                    if (!state.getIn(['solicitud', 'viaje', 'asistencia_viajero'])) {
                        p.asistencia = null;
                    }

                    state = state.setIn(['solicitud', 'viaje', 'pasajeros',i], Immutable.fromJS(p))
                }
            }

            if (state.getIn(['solicitud', 'viaje', 'cant_pasajeros']) < state.getIn(['solicitud', 'viaje', 'pasajeros']).count() && state.getIn(['solicitud', 'viaje', 'cant_pasajeros']) != 0) {
                const pasajeros = state.getIn(['solicitud', 'viaje', 'pasajeros']).toJS().splice(0,state.getIn(['solicitud', 'viaje', 'cant_pasajeros']))
                state = state.setIn(['solicitud', 'viaje', 'pasajeros'], Immutable.fromJS(pasajeros))
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'tipo_viaje') {
                for(let i=0; i < state.getIn(['solicitud', 'viaje', 'cant_pasajeros']); i++) {
                    state = state.setIn(['solicitud', 'viaje', 'pasajeros',i, 'guid'], guid())
                }
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'tipo_trayecto' && action.payload.value != 3) {
                const trayectos = state.getIn(['solicitud', 'viaje', 'trayectos']).toJS().splice(0,1)
                state = state.setIn(['solicitud', 'viaje', 'trayectos'], Immutable.fromJS(trayectos))
            }



            if (action.payload.path.split('.').slice(-1)[0] == 'tipo_trayecto' && action.payload.value != 1) {
                state.getIn(['solicitud', 'viaje', 'pasajeros']).map((p,i) => {
                    if (state.getIn(['solicitud', 'viaje', 'pasajeros', i, 'asistencia']) != null)
                        state = state.setIn(['solicitud', 'viaje', 'pasajeros', i, 'asistencia', 'fecha_regreso'], null)
                })
            }
            if (action.payload.path.split('.').slice(-1)[0] == 'asistencia_viajero') {
                state.getIn(['solicitud', 'viaje', 'pasajeros']).map((p,i) => {
                    if (!state.getIn(['solicitud', 'viaje', 'pasajeros', i, 'asistencia']) && action.payload.value)
                        state = state.setIn(['solicitud', 'viaje', 'pasajeros', i, 'asistencia'], Immutable.fromJS(asistencia()))
                    else if (!action.payload.value)
                        state = state.setIn(['solicitud', 'viaje', 'pasajeros', i, 'asistencia'], null)
                })
            }

            // if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
            //     let newPath = action.payload.path.split('.')
            //     newPath = newPath.splice(0, newPath.length-1)
            //     if (newPath[newPath.length-1] == 'pivot') {
            //         state = state.setIn([...newPath, 'selected'], true)
            //     }
            // }


            return state


        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO:
            state = state.setIn(`${action.payload.path}`.split('.'), action.payload.data)
            return state
        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_TIQUETESAEREO1:
            index = action.payload
            adjuntos = state.get('adjuntos').findIndex(x => x.get('guid') === index.get('guid'))
            index = index.set('nombre', `${index.get('nombre')}`)
            if (adjuntos === -1) {
                state = state.set('adjuntos', state.get('adjuntos').push(index))
            } else {
                index = index.set('updated', true)
                state = state.setIn(['adjuntos', String(adjuntos)], index)
            }
            return state


        case types.ADICIONAR_COTIZACION_TIQUETESAEREO:
            index = state.getIn(['solicitud', 'cotizaciones']).findIndex(x => x.get('guid')==action.payload.data.get('guid'))
            if (index == -1) {
                index = state.getIn(['solicitud', 'cotizaciones']).count()
            }
            state = state.setIn(['solicitud', 'cotizaciones', index], action.payload.data)
            return state

        case types.MODIFICAR_TIQUETE:
            state = state.setIn(['solicitud', 'viaje', 'pasajeros', action.payload.index], action.payload.data)
            return state


        case types.MODIFICAR_ASISTENCIA:
            state = state.setIn(['solicitud', 'viaje', 'pasajeros', action.payload.index], action.payload.data)
            return state


		case types.DESHABILITAR_BOTON_SALVAR_SOLICITUD_TIQUETESAEREO:
			state = state.set('btnSaveDisabled', action.payload)
            return state


        case types.ACTUALIZAR_SOLICITUD_TIQUETESAEREO:
            action.payload.solicitud.cotizaciones = action.payload.solicitud.cotizaciones.filter(cot =>
                cot.viaje.filter(v => v.activo).length > 0
            )
            action.payload.aprobadores = action.payload.aprobadores.filter(a1 => {
                a1.aprobaciones = a1.aprobaciones.filter(a2 => {
                    return action.payload.solicitud.cotizaciones.findIndex(cot => a2.cotizacione.id == cot.id) >= 0
                })
                return a1.aprobaciones.length > 0;
            })

            const ops = diff(state.get('solicitud'), Immutable.fromJS(action.payload.solicitud))
            state = state.set('solicitud', patch(state.get('solicitud'), ops))
            if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
                state = state.set('estado', state.getIn(['solicitud', 'estado']))
            }
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            state = state.set('btnRComprasDisabled', true)
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state


        case types.SELECCIONAR_APROBACION_SOLICITUD_TIQUETESAEREO:
            state = state.updateIn(['aprobadores', action.payload.indexAprobador, 'aprobaciones'], list => list.map(x => x.set('estado', 1)))
            state = state.setIn(['aprobadores', action.payload.indexAprobador, 'aprobaciones', action.payload.indexAprobacion, 'estado'], 2)
            return state


        case types.REMOVER_COTIZACION_TIQUETESAEREO:
            state = state.updateIn(['solicitud', 'cotizaciones'], list => list.filter(x => !x.get('selected')))
            return state
        case types.EDITAR_ARCHIVO_PASAPORTE:
            let data = action.payload.data.get('id') ? action.payload.data.set('id', null) : action.payload.data
            data = data.get('guid') ? data.set('guid', guid()) : data

            state = state.setIn(['solicitud', 'viaje', 'pasajeros', action.payload.index, 'adjunto'], data)
            state = state.setIn(['solicitud', 'viaje', 'pasajeros', action.payload.index, 'adjunto_id'], null)
            state = state.setIn(['solicitud', 'viaje', 'pasajeros', action.payload.index, 'guid'], guid())

            return state
        case types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_TIQUETESAEREO1:
            state = state.setIn(action.payload.path.split('.'),  Immutable.fromJS(action.payload.value))
            return state
        case types.ADICIONAR_TRAYECTO1:
                index = state.getIn(['solicitud', 'viaje', 'trayectos']).count()
                state = state.setIn(['solicitud', 'viaje', 'trayectos', index], Immutable.fromJS(trayecto()))
                return state
        case types.REMOVER_TRAYECTOS1:
            state = state.updateIn(['solicitud', 'viaje', 'trayectos'], list => list.filter(x => !x.get('selected')))
            return state
        case types.ADICIONAR_NUEVO_CENCO_SOLICITUD_TIQUETESAEREO1:
            let actual = state.getIn(['solicitud', 'viaje', 'cencos']).reduce((a,b) => {a+=Number(b.getIn(['pivot', 'porcentaje'])); return a}, 0)
            state = state.updateIn(['solicitud', 'viaje', 'cencos'], list => list.push(Immutable.fromJS({pivot:solicitudcenco(actual)})))
            return state
        case types.REMOVER_CENCOS_TIQUETESAEREOS1:
            return state.updateIn(['solicitud', 'viaje', 'cencos'], list => list.filter(x => !x.get('selected')))

        case types.EDITAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1:
            index = state.getIn(['solicitud','foros']).findIndex(c => c.get('id') === action.payload.id)
            state = state.setIn(['comentario','id'], action.payload.id)
            state = state.setIn(['comentario','texto'], state.getIn(['solicitud', 'foros', index, 'comentario']))
            return state

        case types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_TIQUETESAEREO1:
            state = state.setIn(['comentario','btnSendDisabled'], action.payload)
            return state

        case types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_TIQUETESAEREO1:
            state = state.setIn(['solicitud','foros'], Immutable.fromJS(action.payload.foros))
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state


       	default:
            return state

	}
}



// WEBPACK FOOTER //
// ./src/reducers/tiquetesaereo.js